<template>
    <div class="container-fluid">
        <div class="row navbar navbar-light bg-light">
            <div class="col-md-3 col-10 pl-0">
                <h3 class="d-block md-small-text">Messages</h3>
            </div>
            <div class="col-md-6 col-1 lookup-handle hide-on-mobile">
                <router-link v-if="otherUser" :to="{ name: 'lookup-handle', params: { handle: otherUser.handle } }">
                    <img v-if="otherUser.photo" :src="userMainPhoto(otherUser.photo)" 
                    class="float-left message-user-photo rounded-circle img-thumbnail mx-2" 
                    :alt="`${otherUser.name} aNewItem's profile`">
                    <i v-else class="float-left far fa-user-circle fa-3x mx-2"></i>
                    <h4 class="float-left mt-2 text-capitalize">{{otherUser.name}}</h4>
                </router-link>
            </div>
            <div class="col-md-3 col-1 text-right">
                <!-- quick mark-item-as-sold btn displays here, for sellers view alone -->
                <span v-if="thread && thread.seller.id === user._id" @click="showMarkAsSold = true" class="show-mark-as-sold" title="Mark this item as sold">
                    <i class="fas fa-wallet fa-2x text-dark-green clickable mr-4"></i>
                </span>
                <router-link :to="{ name: 'profile' }" class="text-danger" title="Return to my account">
                    <span @click="destroyLookedupUser"><i class="destroy-lookedup-user far fa-window-close fa-2x"></i></span>
                </router-link>
            </div>
        </div>
        <div class="row">
            <div class="col-md-3 col-12 sidebar-scroll let-height-reach-window-bottom">
                <!-- items looped here -->
                <app-sidebar :key="forceReloadKey"></app-sidebar>
            </div>
            <div class="col-md-9 col-12 p-0">
                <div class="row buyer-mobile-header hide">
                    <div class="col-md-9 col-9 lookup-handle">
                        <router-link v-if="otherUser" :to="{ name: 'lookup-handle', params: { handle: otherUser.handle } }">
                            <img v-if="otherUser.photo" :src="userMainPhoto(otherUser.photo)" 
                            class="float-left message-user-photo rounded-circle img-thumbnail mx-2" 
                            :alt="`${otherUser.name} aNewItem's profile`">
                            <i v-else class="float-left far fa-user-circle fa-3x mx-2"></i>
                            <h4 class="float-left mt-2 text-capitalize">{{otherUser.name}}</h4>
                        </router-link>
                    </div>
                    <div class="col-md-3 col-3 text-right">
                        <!-- quick mark-item-as-sold btn displays here, for sellers view alone -->
                        <span v-if="thread && thread.seller.id === user._id" @click="showMarkAsSold = true" title="Mark this item as sold">
                            <i class="fas fa-wallet fa-2x text-dark-green clickable mt-1 show-mark-as-sold-mobile"></i>
                        </span>
                    </div>
                </div>
                <!-- item buyer mobile header -->
                <!-- item buyer messages here -->
                <app-display></app-display>
            </div>
        </div>

        <!-- show mark item as sold -->
        <app-mark-as-sold v-if="showMarkAsSold && thread" :itemId="thread.item.id"></app-mark-as-sold>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { appendImgHostUrl } from '@/store/dry'
import { eventBus } from '@/main'

import Sidebar from './messageParts/Sidebar.vue'
import Display from './messageParts/Display.vue'
import LayoutUser from '@/layouts/User.vue'
import MarkAsSold from './sellingParts/MarkAsSold.vue'


export default {
    name: "Messages",
    data() {
        return {
            showMarkAsSold: false,
            forceReloadKey: 0
        }
    },
    methods: {
        ...mapActions(['footerFixed', 'closeLookedupUserH']),
        toggleBodyClass(addRemoveClass, className) {
            const el = document.body; // select body element
            if (addRemoveClass === 'addClass') {
                el.classList.add(className);
            } else {
                el.classList.remove(className);
            }
        },
        userMainPhoto(path) {
            if(!path) return ''
            return appendImgHostUrl(path)
        },
        destroyLookedupUser() {
            this.closeLookedupUserH().then(() => {}).catch((e) => {})
        }
    },
    computed: {
        ...mapGetters(['msgThread', 'user']),
        thread() {
            if(this.msgThread && this.msgThread !== null){
                return this.msgThread
            }
            return false
        },
        otherUser() {
            if(this.thread){
                if(this.thread.seller.id == this.user._id){
                    return this.thread.buyer
                }else{
                    return this.thread.seller
                }
            }
            return false
        },
    },
    watch: {
        msgThread(){
            this.forceReloadKey += 1
        }
    },
    components: {
        appSidebar: Sidebar,
        appDisplay: Display,
        appMarkAsSold: MarkAsSold
    },
    created() {
        eventBus.$on('hideGhostMode', (value) => {
            this.showMarkAsSold = value;
        })
        this.$emit('update:layout', LayoutUser)
    },
    mounted() {
        this.toggleBodyClass('addClass', 'no-movement')
        this.footerFixed(true)
    },
    destroyed() {
        this.toggleBodyClass('removeClass', 'no-movement')
        this.footerFixed(false)
    }
}
</script>